import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import undefsafe from 'undefsafe'
import classnames from 'classnames'

import menuBuilder from './menuBuilder'
import UserIcon from '../../../icons/user'

class SignedInMenu extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    currentSite: PropTypes.string.isRequired
  }

  blockTitle (entry) {
    return (
      <li key={entry.title} className='global-header-dropdown__list-title'>
        {entry.title}
      </li>
    )
  }

  blockEntry (entry) {
    const { user } = this.props
    const credit = '$' + undefsafe(user, 'profile.total_deposits')
    const entryClassNames = classnames('global-header-dropdown__list-item',
      { '-border-top fds-u-pt1 fds-u-mt1': entry.isLastEntry })
    const linkClassNames = classnames('global-header-dropdown__link',
      { 'fds-u-pb0': entry.isLastEntry })

    return (
      <li className={entryClassNames} key={entry.label}>
        <a href={entry.path} className={linkClassNames}>
          <span className='global-header-dropdown__link-text'>
            {entry.label}
          </span>
        </a>
        { entry.showCredit &&
          <p className='global-header-dropdown__text'>{entry.creditLabel} {credit}</p>
        }
      </li>
    )
  }

  /*
   build the user entries if the user has been loaded and there is a valid
   profile. Returns an empty array instead if the user does not have the profile
  */
  userMenuEntries () {
    const { user, currentSite } = this.props

    if (user && user.profile) {
      return menuBuilder(user, currentSite)
    } else {
      return []
    }
  }

  render () {
    const { user } = this.props
    const earnings = undefsafe(user, 'profile.available_earnings')
    const earningsLabel = '$' + earnings
    const hasPositiveEarnings = parseInt(earnings) > 0
    const username = undefsafe(user, 'profile.username')

    return (
      <li className='global-header-menu__list-item--with-dropdown -background-light -border-radius'>
        <Link to='#' className='global-header-menu__link'>
          <UserIcon className='global-header-menu__icon'
            width='16px' height='16px' />
          <span className='global-header-menu__link-text has-truncated-length -weight-bold'>
            {username}
          </span>
          {hasPositiveEarnings &&
            <span className='global-header-menu__link-text'>
              Earnings: {earningsLabel}
            </span>
          }
        </Link>

        <div className='global-header-menu__dropdown-container'>
          <div className='global-header-dropdown'>
            <ul className='global-header-dropdown__list'>
              {
                this.userMenuEntries().map((entry) => {
                  return (entry.title
                    ? this.blockTitle(entry) : this.blockEntry(entry)
                  )
                })
              }
            </ul>
          </div>
        </div>
      </li>
    )
  }
}

export default SignedInMenu



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/signedInMenu.js